import { Injectable } from '@angular/core';
import { SortType, SortDirection } from '../constants-types/Enums';
import {
    FilterInfo,
    FilterIndexContext,
    FilterType
} from '../core-data-model/FilterInfo.model';
import { SortInfo } from '../core-data-model/SortInfo.model';
import {
    ODataQueryGeneratorService,
    KeyValue,
    UnknownFilterTypeError
} from '../core-services/ODataQueryGenerator.service';

// https://pi-develop-app-classic.azurewebsites.net/api/v2/companies/507e0ad8-a595-4b05-8801-34284370f8b0/positions/6e040b05-076c-48a5-b7e5-aab788759a12/associatedPersons?$skip=0&$top=10&$orderby=jobAssociatedPeople/person/assessmentUser/lastName%20asc,%20jobAssociatedPeople/person/assessmentUser/firstName%20asc

@Injectable({ providedIn: 'root' })
export class JobMatchQueryGeneratorService extends ODataQueryGeneratorService {
    getDefaultSearchFields() {
        const person = 'jobAssociatedPeople/person';
        const assessmentUser = `${person}/assessmentUser`;
        return [
            `${person}/sortName`,
            `${assessmentUser}/firstName`,
            `${assessmentUser}/lastName`,
            `${assessmentUser}/email`
        ];
    }

    getOrderbyParameter(sortingState: SortInfo[]): KeyValue[] {
        const sortList = sortingState
            // removed this because not supported on server yet
            // oDataSort = `combinedFitScore`;
            // .filter((sortInfo: SortInfo) => {
            //    return ![
            //        SortType.MatchScoreOverall,
            //        SortType.MatchScoreBehavioral,
            //        SortType.MatchScoreCognitive
            //    ].includes(sortInfo.sortType);
            // })
            .map((sortInfo: SortInfo) => {
                let oDataSort;
                const oDataDirection =
                    sortInfo.direction === SortDirection.Ascending
                        ? 'asc'
                        : 'desc';
                const person = 'jobAssociatedPeople/person';
                const assessmentUser = `${person}/assessmentUser`;
                switch (sortInfo.sortType) {
                    case SortType.Name: {
                        const lastName = `${assessmentUser}/lastName`;
                        const firstName = `${assessmentUser}/firstName`;
                        return `${lastName} ${oDataDirection}, ${firstName} ${oDataDirection}`;
                    }
                    case SortType.FirstName: {
                        const personLastName = `${assessmentUser}/lastName`;
                        const personFirstName = `${assessmentUser}/firstName`;
                        return `${personFirstName} ${oDataDirection}, ${personLastName} ${oDataDirection}`;
                    }
                    case SortType.PersonType:
                        oDataSort = `${assessmentUser}/personType`;
                        break;
                    case SortType.ReferenceProfile:
                        oDataSort = `${person}/assessmentInformation/behavioralAssessmentInformation/originalReferencePatternName`;
                        break;
                    case SortType.MatchScoreOverall:
                        oDataSort = `${person}/assessmentUser/combinedJobFitScore`;
                        break;
                    case SortType.MatchScoreBehavioral:
                        oDataSort = `${person}/assessmentUser/behavioralJobFitScore`;
                        break;
                    case SortType.MatchScoreCognitive:
                        oDataSort = `${person}/assessmentUser/cognitiveJobFitScore`;
                        break;
                    case SortType.Favorite:
                        oDataSort = `${assessmentUser}/impression`;
                        break;
                    case SortType.RecentlyCompleted:
                        oDataSort = `${person}/assessmentInformation/latestAssessmentCompletedDate`;
                        break;
                    case SortType.LastUpdated:
                        oDataSort = `${person}/sortDate`;
                        break;
                    default:
                        throw new UnknownFilterTypeError();
                }
                return `${oDataSort} ${oDataDirection}`;
            });
        if (sortList.length > 0) {
            return [
                {
                    key: '$orderby',
                    value: sortList.join(',')
                }
            ];
        }
        return [];
    }

    protected filterFilterList(filters: FilterInfo[]): FilterInfo[] {
        if (!filters || filters.length > 1) {
            return filters;
        }

        // We only allow searching within Hire2.
        // So if there's only one filter that's "search" then clear out default filters.
        // This is to support backward compatibility with Hire1
        const searchFilter = filters.find(
            (filter: FilterInfo) => filter.type === FilterType.Search
        );

        return searchFilter ? [] : filters;
    }

    protected makeFilterContext() {
        return {
            indexContext: FilterIndexContext.JobMatch,
            showCognitive: this.userProfile.showCognitive,
            userGuid: this.initData.user.userGuid
        };
    }
}
